export default "__VITE_ASSET__CxuDlPpn__"